<template>
  <div class="container diy-page">
    <v-head></v-head>
    <v-left current="returns"></v-left>
    <div>
      <el-tabs v-model="filter.status" @tab-click="handleClick">
        <el-tab-pane :label="st.label + '(' + st.count + ')'" :name="st.value" v-for="(st, index_st) in statics" :key="index_st"></el-tab-pane>
      </el-tabs>
        
      <div style="margin:10px 0;">
          <el-date-picker
            size="small"
            style="width: 366px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-select v-model="filter.app_id" placeholder="店铺" size="small" clearable style="width:133px;">
            <el-option v-for="item in $store.state.public.cfg.apps_options" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>  
          <el-select v-model="filter.package_status" placeholder="包裹状态" size="small" clearable style="width:133px;">
            <el-option v-for="item in $store.state.public.cfg.package_status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input placeholder="请输入内容" clearable v-model="filter.keyword" class="input-with-select" style="width:499px;" size="small">
            <el-select v-model="filter.keyword_type" slot="prepend" placeholder="请选择" style="width:122px">
              <el-option label="智能识别" value="auto"></el-option>
              <el-option label="平台编号" value="platform_order_number"></el-option>
              <el-option label="订单号" value="order_no"></el-option>
              <el-option label="物流单号" value="logistics_track_number"></el-option>
              <el-option label="工厂单号" value="factory_order_no"></el-option>
              <el-option label="邮箱" value="email"></el-option>
              <el-option label="手机号" value="mobile"></el-option>
              <el-option label="备注" value="remark"></el-option>
              <el-option label="YOURNAME" value="your_name"></el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
      </div>
      
      
      <el-table
          v-if="list_data"
          :data="list_data.list"
          v-loading="loading"
          style="width: 100%"
          ref="multipleTable"
          tooltip-effect="dark"
          border
        >
          <el-table-column prop="order_no" label="Order" width="155" :key="Math.random()">
            <template slot-scope="scope">
              <div><a>#{{ scope.row.platform_order_name }}</a></div>
              <div><el-tag style="small" :type="scope.row.el_tag">{{ scope.row.status }}</el-tag></div>
            </template>
          </el-table-column>
          <el-table-column prop="items" label="Items" min-width="666" :key="Math.random()">
            <template slot-scope="scope">
              <el-table
                :data="scope.row.items"
                style="width: 100%"
                border
              >
                <el-table-column prop="image" label="image" width="255" :key="Math.random()">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 100px"
                      v-if="scope2.row.order_goods.image"
                      :src="scope2.row.order_goods.image"
                      :preview-src-list="[scope2.row.order_goods.image]"
                    >
                    </el-image>
                    <el-image
                      style="width: 100px"
                      v-if="scope2.row.order_goods.preview_image"
                      :src="scope2.row.order_goods.preview_image"
                      :preview-src-list="[scope2.row.order_goods.preview_image]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="spec" label="spec" width="444" :key="Math.random()">
                  <template slot-scope="scope2">
                    <section v-for="(sp, sp_index) in scope2.row.order_goods.spec_format" :key="sp_index">
                      <p>{{ sp.name }}:{{ sp.value }}</p>
                    </section>
                  </template>
                </el-table-column>
                <el-table-column prop="spec" label="spec" min-width="333" :key="Math.random()">
                  <template slot-scope="scope2">
                    <p><b>Reason</b>: {{ scope2.row.return_reason }}</p>
                    <p><b>Definition</b>: {{ scope2.row.reason_definition_name }}</p>
                    <p v-if="scope2.row.customer_note"><b>Note</b>: {{ scope2.row.customer_note }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="logs" label="Logs" width="333" :key="Math.random()">
            <template slot-scope="scope">
              <ul v-if="scope.row.order_logs">
                <li style="border-bottom: 1px dashed #dfdfdf;margin-bottom: 10px;" v-for="(log, index_l) in scope.row.order_logs" :key="index_l">
                  <p>{{log.title}}{{log.remark}} / {{log.seller_member_name}}</p>
                  <p class="gray-color">{{log.ctime}}</p>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="Handle" width="111" :key="Math.random()">
            <template slot-scope="scope">
              <el-button size="small" @click="to_pop_email(scope.row)">邮件</el-button><br>
              <el-button size="small" type="success" style="margin:5px 0;" @click="to_approve(scope.row)">通过</el-button><br>
              <el-button size="small" type="danger" @click="to_refuse(scope.row)">拒绝</el-button>
            </template>
          </el-table-column>
      </el-table>
      <el-pagination
        class="my-page"
        background
        :page-sizes="[10, 20, 50, 100, 200, 300, 400]"
        :current-page="list_data.page"
        :page-size="list_data.size"
        layout="total, prev, pager, next"
        @current-change="changePage"
        @size-change="handleSizeChange"
        :total="list_data.total"
      >
      </el-pagination>
    </div>

    <component
      :is="popName"
      :orders="edit_row"
      :email_message_type="email_message_type"
      :email_detail_id="0"
      :account=null
    ></component>

  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_email = (resolve) => require(["@/pages/email/_pop_compose"], resolve);

export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_email:pop_email,
  },
  data() {
    return {
      uid:0,
      loading:false,
      popName:null,
      edit_row:null,
      email_message_type:2,
      filter:{
        status:"REQUESTED",
        keyword_type:"",
        keyword:"",
        page:1,
        size:20,
        app_id:"",
        package_status:"",
        time_range:[],
      },
      list_data:{
        page:1,
        size:20,
        total:0,
        list:[],
      },
      statics:[],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    handleClick(e) {
      this.getList();
    },
    to_pop_email(orders){
      this.popName = "pop_email";
      this.edit_row = orders;
    },
    to_approve(orders){
      this.$confirm('Approve ?' + this.filter.keyword, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在提交审批.." });
        this.$http.post("/v1/pri/orders-returns/approve", {platform_order_name:orders.platform_order_name}).then((response) => {
          this.$store.commit("setLoading", false);
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getList()
          } else {
            this.$message({
                message: res.msg,
                type: 'warning'
            });
          }
        });
      }).catch(() => {});
    },
    to_refuse(orders){
      this.$confirm('Refuse ?' + this.filter.keyword, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在提交审批.." });
        this.$http.post("/v1/pri/orders-returns/refuse", {platform_order_name:orders.platform_order_name}).then((response) => {
          this.$store.commit("setLoading", false);
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getList()
          } else {
            this.$message({
                message: res.msg,
                type: 'warning'
            });
          }
        });
      }).catch(() => {});
    },
    changePage(e) {
      this.list_data.list = [];
      this.list_data.total = 0;
      this.filter.page = e;
      this.getList();
    },
    handleSizeChange(val) {
      this.filter.size = val;
      this.filter.page = 1;
      this.getList();
    },
    search(){
      this.filter.page = 1;
      this.filter.status = "ALL";
      this.getList();
    },
    getStatics(){
      this.$http.post("/v1/pri/orders-returns/statics", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          this.statics = res.data;
        }
      });
    },
    getList(){
      this.loading = true;
      this.$http.post("/v1/pri/orders-returns/list", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          this.list_data = res.data;
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      var tab = this.getUrlParam('tab')
      if (tab) { 
        this.activeName = tab
      }
    })
    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }


    this.getStatics();
    this.getList();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/returns/Index.vue